<template>
    <div class="columns">
        <div class="column is-fullwidth">
            <h4 class="is-size-4 is-inline region-header" @click="selectAllAuctionsByRegion(region)">
                {{ region }}
            </h4>
            <button class="button is-primary is-pulled-right" v-if="counter === 0" @click="selectAllAuctionsByDay">
                Select all
            </button>
            <hr>
            <div class="columns is-multiline is-flex">
                <app-location-image v-for="(auction, index) in getAuctionsByRegion(region)"
                                    :auction="auction"
                                    :key="index"/>
            </div>
        </div>
    </div>
</template>

<script>
    import LocationImage from './LocationImage'
    export default {
        props: ['region', 'counter'],
        components: {
            appLocationImage: LocationImage
        },
        methods: {
            getAuctionsByRegion(region) {
                return this.$store.getters.getAuctionsByRegion(region)
            },
            selectAllAuctionsByRegion(region) {
                this.$store.dispatch('addAllAuctionsByRegion', region)
            },
            selectAllAuctionsByDay() {
                 this.$store.dispatch('addAllAuctionsByActiveDay')
            }
        }
    }
</script>

<style scoped>
    .region-header {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Locations/LocationsContainer.vue